module.exports = __webpack_public_path__ + "media/images/riders/small/SAM_DALE-9cb134e39b0439f90a4e3c100a2c49e0.png";